import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

// Shown under the Library category dropdown when "Commission" is selected.
// Non-dismissible per PRD AC 2.2.3 — visibility derived solely from the active dropdown value.
const MathTierWarning = () => (
  <div
    className="alert alert-info d-flex align-items-start mb-3"
    role="alert"
    data-testid="library-math-tier-warning"
  >
    <FontAwesomeIcon icon="fas fa-calculator" className="mr-2 mt-1" />
    <span>
      Commission templates use the Reasoning model for accurate calculations.
      Generation may take 30-60 seconds.
    </span>
  </div>
);

export default MathTierWarning;
